"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var core_1 = require("@material-ui/core");
var Layout_css_1 = __importDefault(require("./Layout-css"));
var SearchHeader_1 = __importDefault(require("../SearchHeader/SearchHeader"));
var Navigation_1 = __importDefault(require("../Navigation/Navigation"));
var Layout = function (_a) {
    var _b = _a.showSearchHeader, showSearchHeader = _b === void 0 ? true : _b, props = __rest(_a, ["showSearchHeader"]);
    var styles = props.styles, className = props.className, location = props.location, navigation = props.navigation, navigationStyles = props.navigationStyles, navigationClass = props.navigationClass, navigationComponent = props.navigationComponent, searchHeaderStyles = props.searchHeaderStyles, searchHeaderClass = props.searchHeaderClass, contentStyles = props.contentStyles, contentClass = props.contentClass, children = props.children, searchHeaderProps = __rest(props, ["styles", "className", "location", "navigation", "navigationStyles", "navigationClass", "navigationComponent", "searchHeaderStyles", "searchHeaderClass", "contentStyles", "contentClass", "children"]);
    return (react_1.default.createElement(core_1.MuiThemeProvider, { theme: props.theme },
        react_1.default.createElement("div", { className: "" + (className || ""), style: __assign(__assign({}, Layout_css_1.default[props.dense ? "invosys-ui-Layout-dense" : "invosys-ui-Layout"]), (styles || {})) },
            props.navigation && (react_1.default.createElement("div", { className: "" + (navigationClass || ""), style: __assign(__assign({}, Layout_css_1.default["invosys-ui-Layout-navigation"]), (navigationStyles || {})) }, Array.isArray(navigation) ? (react_1.default.createElement(Navigation_1.default, { navs: navigation, component: navigationComponent, location: location || {}, dense: props.dense })) : (navigation))),
            showSearchHeader && (react_1.default.createElement(core_1.Paper, { className: "" + (searchHeaderClass || ""), style: __assign(__assign({}, Layout_css_1.default[props.dense
                    ? "invosys-ui-Layout-searchBar-dense"
                    : "invosys-ui-Layout-searchBar"]), (searchHeaderStyles || {})) }, props.searchHeader || react_1.default.createElement(SearchHeader_1.default, __assign({}, searchHeaderProps)))),
            react_1.default.createElement(core_1.Paper, { className: "" + (contentClass || ""), style: __assign(__assign({}, Layout_css_1.default["invosys-ui-Layout-content"]), (contentStyles || {})) }, children))));
};
Layout.propTypes = {
    styles: prop_types_1.default.object,
    className: prop_types_1.default.string,
    location: prop_types_1.default.object,
    navigation: prop_types_1.default.oneOfType([prop_types_1.default.node, prop_types_1.default.array]),
    navigationStyles: prop_types_1.default.object,
    navigationClass: prop_types_1.default.string,
    searchHeaderStyles: prop_types_1.default.object,
    searchHeaderClass: prop_types_1.default.string,
    contentStyles: prop_types_1.default.object,
    contentClass: prop_types_1.default.string,
    showSearchHeader: prop_types_1.default.bool,
    searchHeader: prop_types_1.default.node,
    children: prop_types_1.default.oneOfType([prop_types_1.default.node, prop_types_1.default.array]),
    navigationComponent: prop_types_1.default.any,
    theme: prop_types_1.default.any,
    dense: prop_types_1.default.bool
};
exports.default = Layout;
